<template>
  <card-container
    :id="pageId"
    loading-message="Loading Customers..."
    button-location="top"
    :is-loading="status.isLoading"
  >
    <template #title>
      Customers
    </template>

    <template #top-form>
      <div class="row align-items-center">
        <pagination
          :is-loading="status.isLoading"
          :current-page="pagination.currentPage"
          :total-pages="pagination.totalPages"
          @load-page-data="loadAffiliateCustomers"
        />
      </div>
      <message-html
        :result-html="status.resultHtml"
        has-bottom-line
      />
    </template>

    <template #content>
      <table-view-container
        :page-id="pageId"
        :data="customerList"
        :table-columns="callerTableColumnsInAffiliateDB"
        :fixed-column-counts="2"
      />
    </template>
  </card-container>
</template>

<script lang="ts">
import { ref, Ref, onMounted, reactive } from 'vue';

import util from '@/Utils/util';
import { useCustomer } from '@/use/customer';
import { useAffiliate } from '@/use/affiliate';
import { callerTableColumnsInAffiliateDB } from '@/constants/caller';
import { callerService } from '@/services/caller';

const pageId = 'affilicate-customers';
const pageLimit = 10;

export default {
  name: 'AffilicateCustomers',

  setup: () => {
    const { id: affiliateId } = useAffiliate();
    const { formatCustomerInfo } = useCustomer();

    const customerList: Ref<any> = ref([]);
    const status = reactive({
      isLoading: false,
      resultHtml: '',
    });
    const pagination = reactive({
      currentPage: 1,
      totalPages: 1,
    });

    const loadAffiliateCustomers = async (currentPage: number = 1) => {
      pagination.currentPage = currentPage;

      status.isLoading = true;
      try {
        const callers = await callerService.fetchCustomers({
          pagination: {
            limit: pageLimit,
            offset: (currentPage - 1) * pageLimit,
          },
          affiliateId: affiliateId.value,
        });

        pagination.totalPages = Math.ceil(callers.count / pageLimit) || 1;

        // format caller data to show table
        customerList.value = callers.rows.map((customer: any, index: number) => {
          const formattedCustomer = formatCustomerInfo(customer);
          formattedCustomer.index = (currentPage - 1) * pageLimit + index + 1;

          return formattedCustomer;
        });
      } catch (error) {
        customerList.value = [];

        pagination.totalPages = 1;
        pagination.currentPage = 1;

        status.resultHtml = util.getGraphqlError(error);
      }
      status.isLoading = false;
    };

    onMounted(loadAffiliateCustomers);

    return {
      pageId,
      callerTableColumnsInAffiliateDB,
      customerList,
      status,
      pagination,

      loadAffiliateCustomers,
    };
  },
};
</script>
